import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import Link from 'molecules/Link';
import './Button.scss';

/**
 * Button.
 */
const propTypes = {
  color:    PropTypes.string,
  htmlType: PropTypes.string,
  icon:     PropTypes.node,
  link:     PropTypes.object, // Link props.
  size:     PropTypes.string,
  type:     PropTypes.string,
  onClick:  PropTypes.func,
}
const defaultProps = {
  color: 'blue',
  type:  'default',
}
const Button = p => {

  if( ! p.link && ! p.onClick && p.htmlType !== 'submit' ) {
    throw new Error( 'Button needs some sort of functionality.' );
  }

  /* ------ = Output. = --------------------------------------------------------------------- */

  const className = classnames(
    'Btn',
    p.className,
     {
      [`is-${p.color}`]: !! p.color,
      [`is-${p.type}`]: !! p.type,
      [`is-${p.size}`]: !! p.size,
      [`is-busy`]: !! p.isBusy,
    }
  );

  if( !! p.link ) {

    return(

      <Link
      className={ className }
      to={ p.link.to }
      target={ p.link.target }
      style={ p.style }
      onClick={ p.onClick }
      download={ p.link.download }
      >

        { p.icon &&

          <span className="Btn__icon">
            { p.icon }
          </span>

        }

        <span className="Btn__txt">
          { p.children }
        </span>

      </Link>

    )
  }

  else {

    return(

      <button
      className={ className }
      style={ p.style }
      disabled={ p.disabled || p.isBusy }
      onClick={ p.onClick }
      >

        { p.icon &&

          <span className="Btn__icon">
            { p.icon }
          </span>

        }
        <span className="Btn__txt">
          { p.children }
        </span>

      </button>

    );
  }

};
Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
